import Head from 'next/head'
import * as React from 'react'
import { InjectedIntlProps } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators, compose, Dispatch } from 'redux'
import Cookie from 'design-system/src/components/Cookie/Cookie'
import 'design-system/theme/norbert/index.css'
import 'design-system/theme/norbert/phoneInput.css'

// @ts-ignore
import { actionCreators } from '../api/cookies'
import BrowserIcons from '../components/BrowserIcons'
import FlashMessage from '../flashMessage/FlashMessage'
import { Footer } from '../components/Footer'
import Header from '../components/Header'
import Callout from '../components/Callout'
// @ts-ignore
import withIntl from '../withIntl'

import styles from './Layout.css'

interface DispatchToProps {
  readAuthTokenCookie: typeof actionCreators.readAuthTokenCookie
}

interface LayoutProps extends DispatchToProps, InjectedIntlProps {
  children: React.ReactElement<unknown>
  pageProps: {
    disableLinkToHome?: boolean
  }
}

export class Layout extends React.Component<LayoutProps> {
  componentDidMount () {
    this.props.readAuthTokenCookie()
  }

  calloutBox () {
    const broadcast: {
      [name: string]: ReactIntl.FormattedMessage.MessageDescriptor
    } = {
      title: {
        id: 'shared.broadcast-title'
      },
      message: {
        id: 'shared.broadcast-message'
      }
    }

    const formatMessage = (
      messageDescriptor: ReactIntl.FormattedMessage.MessageDescriptor
    ): string => {
      const formatted = this.props.intl.formatMessage(messageDescriptor)

      if (formatted === messageDescriptor.id) {
        return ''
      }

      return formatted
    }

    const title = formatMessage(broadcast.title)
    const message = formatMessage(broadcast.message)

    if (title || message) {
      return <Callout title={title} message={message} />
    }

    return null
  }

  render () {
    const { children, intl, pageProps = {} } = this.props
    const locale = intl.locale.split('-')[0]

    return (
      <div className={styles.root}>
        <Head>
          <title>
            {intl.formatMessage({
              id: 'title'
            })}
          </title>
          {BrowserIcons()}
        </Head>
        <Header
          key='app-header'
          disableLinkToHome={pageProps.disableLinkToHome}
        />
        <FlashMessage />
        <main className={styles.main} key='app-main'>
          {this.calloutBox()}
          {children}
        </main>
        <Footer key='app-footer' locale={locale} />
        <Cookie
          notice={this.props.intl.formatHTMLMessage(
            { id: 'cookie' },
            { assetPrefix: process.env.ASSET_PREFIX }
          )}
        />
      </div>
    )
  }
}

function mapDispatchToProps (dispatch: Dispatch): DispatchToProps {
  return bindActionCreators(
    {
      readAuthTokenCookie: actionCreators.readAuthTokenCookie
    },
    dispatch
  )
}

export default compose<React.ComponentType<{}>>(
  connect(
    undefined,
    mapDispatchToProps
  ),
  withIntl
  // @ts-ignore
)(Layout)
